import { render, staticRenderFns } from "./DashComissoes.vue?vue&type=template&id=e65a1ecc&"
import script from "./DashComissoes.vue?vue&type=script&lang=ts&"
export * from "./DashComissoes.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports